export default "__VITE_ASSET__DLcfx6Nf__"